const API_BASE =
  process.env.REACT_APP_API_BASE ||
  process.env.REACT_APP_GRAPHQL_URI?.replace(/\/graphql\/?$/, "") ||
  "http://localhost:8080";

export const ADMIN_TOKEN_KEY = "pbj-admin-token";

export function getAdminToken(): string | null {
  return sessionStorage.getItem(ADMIN_TOKEN_KEY);
}

export function clearAdminToken(): void {
  sessionStorage.removeItem(ADMIN_TOKEN_KEY);
}

export function getAdminAuthHeaders(): Record<string, string> {
  const token = getAdminToken();
  if (!token) {
    return {};
  }
  return { Authorization: `Bearer ${token}` };
}

export async function loginAdmin(password: string): Promise<boolean> {
  const response = await fetch(`${API_BASE}/api/admin/login`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ password }),
  });

  if (!response.ok) {
    return false;
  }

  const data = (await response.json()) as { token: string };
  sessionStorage.setItem(ADMIN_TOKEN_KEY, data.token);
  return true;
}
